module.exports = __webpack_public_path__ + "static/media/spicy.fd88da9c.svg";